import { useState, useMemo } from "react";
import { formatNumber } from "@/lib/units";
import ResultsPanel, { CalcPageHeader, Field } from "@/components/ResultsPanel";

export default function RectangleCalculator() {
  const [length, setLength] = useState("50");
  const [width, setWidth] = useState("30");

  const { area, perim, diag } = useMemo(() => {
    const L = Number(length) || 0;
    const W = Number(width) || 0;
    return { area: L * W, perim: 2 * (L + W), diag: Math.sqrt(L * L + W * W) };
  }, [length, width]);

  const rows = [
    ["Area", `${formatNumber(area)} sq units`],
    ["Perimeter", `${formatNumber(perim)} units`],
    ["Diagonal", `${formatNumber(diag)} units`],
  ];

  return (
    <div>
      <CalcPageHeader title="Rectangle Calculator" description="Area, perimeter and diagonal from length & width." slug="rectangle" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        <div className="lg:col-span-7">
          <div className="rounded-lg border border-border bg-card p-5 sm:p-6 grid grid-cols-2 gap-4">
            <Field label="Length"><input data-testid="rect-length-input" type="number" value={length} onChange={(e)=>setLength(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
            <Field label="Width"><input data-testid="rect-width-input" type="number" value={width} onChange={(e)=>setWidth(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
          </div>
        </div>
        <div className="lg:col-span-5 lg:sticky lg:top-24">
          <ResultsPanel title="Rectangle" slug="rectangle" highlight={{ label: "Area", value: formatNumber(area), sub: "square units" }} rows={rows} onReset={()=>{setLength("");setWidth("");}} />
        </div>
      </div>
    </div>
  );
}
